const WEBSITE_URL = "https://formfn.xyz/";

export default WEBSITE_URL;
